import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import * as FaIcons from "react-icons/fa";

const InterestFormCard = ({
  info: {
    _id,
    createdAt,
    age,
    studentFirstName,
    studentLastName,
    parentRelationship,
    parentFirstName,
    parentLastName,
    primaryEmail,
    phone,
    learningCenterName,
    learningCenterAddress,
  },
}) => {
  return (
    <Link to={`/interest-forms/${_id}`} className="interest-form-card">
      <div className="top">
        <div className="left">
          <div className="name">
            <h2>{studentFirstName} {studentLastName}</h2>
            {/* <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#537131' }}>Age: {age}</p> */}
          </div>
          <FaIcons.FaUserCircle className="form-card-icon" />
        </div>
      </div>
      <div className="body">
        <div className="item">
          <h4>Age</h4>
          <p>{age}</p>
        </div>
        <div className="item">
          <h4>Submit Date: </h4>
          <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
        </div>
        <div className="item">
          <h4>Site: </h4>
          <p>{learningCenterName}</p>
        </div>
        {age < 18 && (
          <div className="item">
            <h4>{parentRelationship}: </h4>
            <p>{`${parentFirstName} ${parentLastName}`}</p>
          </div>
        )}
        <div className="item">
          <h4>Phone: </h4>
          <p>{phone}</p>
        </div>
        <div className="item">
          <h4>Email: </h4>
          <p>{primaryEmail}</p>
        </div>
      </div>
    </Link>
  );
};

export default InterestFormCard;
